export const MAX_PDF_FILE_SIZE = 5 * 1024 * 1024;

export const validatePdfUploadFile = (uploadedFile) => {
  if (!uploadedFile) {
    return { isValid: false, errorMessage: "" };
  }

  const fileName = uploadedFile.name?.trim() || "";
  const lowerName = fileName.toLowerCase();
  const parts = lowerName.split(".");

  if (parts.length !== 2 || parts[0].trim() === "" || parts[1] !== "pdf") {
    return {
      isValid: false,
      errorMessage: "File has double extension, please upload correct file.",
    };
  }

  if (uploadedFile.type !== "application/pdf") {
    return {
      isValid: false,
      errorMessage: "Only PDF files are allowed.",
    };
  }

  if (uploadedFile.size > MAX_PDF_FILE_SIZE) {
    return {
      isValid: false,
      errorMessage: "File size must be less than 5 MB.",
    };
  }

  return { isValid: true, errorMessage: "" };
};
